export class AccordionTextModule {
    constructor() {
        if ($(".container-component__accordion-text").length > 0) {
            this.init(); 
        }
    }

    applyCssOnMobile() {
        const mq = window.matchMedia( "(min-width: 480px)" );

        if (mq.matches) {
            $('.container-component__accordion-text').removeClass('container-component__accordion-text');            
        } else {

            $( ".container-component__accordion-text" ).each(function( index ) {

                if (index >= 2) {
                    $(this).addClass('container-component__accordion-text');
                }
            });
        }
    }

    hideContent() {
        let elContent = '.container-component__accordion-text .accordion-text__content';
        if ($(elContent).is(":hidden")){
            $(elContent).show();
        } else {
            $(elContent).hide();
        }        
    }

    bindClick() {

        let elHeading = '.container-component__accordion-text .accordion-text__heading';
      
        $(document).on( "click", elHeading, function() {

            let currentContent = $(this).next('.accordion-text__content');
            let isHidden = currentContent.is(":hidden");
         
            if (isHidden){
                $(this).next('.accordion-text__content').show();
                $(this).addClass('accordion-text__heading--active');
            } else {
                $(this).next('.accordion-text__content').hide();
                $(this).removeClass('accordion-text__heading--active');
            }
        });

        $(document).on("click", ".js-accordion__toggle", function (e) {
            e.preventDefault();

            console.log($(this));

            if ($(this).hasClass('is-on')) {
                $(this).removeClass("is-on");
            }
            else {
                $(this).addClass("is-on");
            }
        });

    }

    registerResizeHandler(){
        window.onresize = this.onResize.bind(this);
    }

    onResize(){
        //this.applyCssOnMobile();
    }

    init() {     
        this.bindClick();
        this.registerResizeHandler();
    }
}
  
    




